import React, {useState, useEffect} from "react";
import "./Top.scss";

export default function Top() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const scrolled =
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20;
      setVisible(scrolled);
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // set initial state

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function scrollToTop() {
    document.body.scrollTop = 0; // Safari
    document.documentElement.scrollTop = 0; // Chrome, Firefox, IE, Opera
  }

  return (
    <button
      onClick={scrollToTop}
      title="Go to top"
      style={{visibility: visible ? "visible" : "hidden"}}
    >
      <i className="fas fa-hand-point-up" aria-hidden="true"></i>
    </button>
  );
}
